import React from 'react';
import { useTranslation } from 'react-i18next';

import MIcon from 'views/MIcon/MIcon';

import classes from './MToast.module.scss';
import { ToastType } from 'utils/enums/toast-types';

type Props = {
  message?: string;
  type?: ToastType;
  className?: string;
  proggressBarClassName?: string;
};

const MToastView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  const defaultMesage = props.type === ToastType.Error ? t('views.toast.message.error') : t('views.toast.message.success');

  return (
    <div
      className={`${classes['container']} ${props.type === ToastType.Error ? classes['container--error'] : ''} ${
        props.className || ''
      }`.trim()}
    >
      <div className={classes['message']}>
        <MIcon name={props.type === ToastType.Error ? 'toastError' : 'toastSuccess'}></MIcon>
        <span>{props.message || defaultMesage}</span>
      </div>
      <div className={`${classes['toastProgressBar']} ${props.proggressBarClassName || ''}`.trim()}></div>
    </div>
  );
};

MToastView.displayName = 'MToastView';
MToastView.defaultProps = {};

export default MToastView;
